<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <!-- CHANGED: Predefined Logos Section -->
      <v-row no-gutters class="mb-4">
        <v-col cols="12">
          <!-- Logo Gallery -->
          <div class="predefined-logos-container">
            <!-- No Logo Option -->
            <div
              class="logo-item"
              :class="{ selected: !options.image }"
              @click="clearLogo"
            >
              <v-icon size="32">mdi-cancel</v-icon>
            </div>
            <!-- Logos from local public folder -->
            <div
              v-for="logoUrl in displayedLogos"
              :key="logoUrl"
              class="logo-item"
              :class="{ selected: options.image === logoUrl }"
              @click="selectPredefinedLogo(logoUrl)"
            >
              <img :src="logoUrl" alt="logo" />
            </div>
          </div>

          <div
            v-if="predefinedLogos.length > initialLogoLimit"
            class="text-center mt-2"
          >
            <v-btn text small color="#011554" @click="toggleGallery" class="btn-border">
              {{ galleryExpanded ? "نمایش کمتر" : "نمایش بیشتر" }}
              <v-icon right>{{
                galleryExpanded ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <!-- END CHANGED SECTION -->

      <v-row no-gutters>
        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-file-input
              v-model="customLogoFile"
              clearable
              dense
              :label="$t('upload_logo')"
              outlined
              prepend-icon=""
              prepend-inner-icon="mdi-camera"
              @change="getImg($event)"
              class="contentinfo"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-imageOptions-upload`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('upload_logo')"
            />
          </div>
        </v-col>

        <!-- ... بقیه کد template بدون تغییر باقی می‌ماند ... -->

        <v-col class="pa-2" cols="12" md="6">
          <v-checkbox
            v-model="options.imageOptions.hideBackgroundDots"
            :disabled="!options.image"
            class="ma-0"
            :label="$t('hide_background_dots')"
            @change="$emit('update')"
          />
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <v-slider
            v-model="computedImgSize"
            :disabled="!options.image"
            append-icon="mdi-image-size-select-large"
            :label="$t('logo_size')"
            max="10"
            min="0"
            step="1"
            thumb-label
            track-color="grey"
          >
            <template v-slot:thumb-label="{ value }">
              <div
                class="d-flex align-center justify-center"
                style="
                  width: 20px;
                  height: 20px;
                  background-color: rgba(12, 15, 26, 0.7);
                  border-radius: 50%;
                "
              >
                {{ value / 10 }}
              </div>
            </template>
          </v-slider>
        </v-col>

        <v-col class="pa-2" cols="12" md="6">
          <div class="rowinfo">
            <v-text-field
              v-model="options.imageOptions.margin"
              :disabled="!options.image"
              dense
              :label="$t('logo_margin')"
              min="0"
              outlined
              class="contentinfo"
              type="number"
              @input="$emit('update')"
            />
            <help-info
              :element-name="`${serviceName}-${componentName}-imageOptions-margin`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('logo_margin')"
            />
          </div>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
// NEW: Import the list of logos from the local file
import predefinedLogos from "@/logos.js";

export default {
  name: "qrCodeLogo",

  props: {
    value: Object,
  },

  data: () => ({
    helpData: [],
    serviceName: "Qrland",
    componentName: "qrCodeLogo",
    imgSize: 5,
    customLogoFile: null,
    predefinedLogos: predefinedLogos, // Get logos from imported file
    galleryExpanded: false, // NEW: State for showing all logos
    initialLogoLimit: 15, // NEW: Number of logos to show initially (e.g. 2 rows)
  }),

  computed: {
    options: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    computedImgSize: {
      get() {
        if (this.options.imageOptions.imageSize === undefined) {
          this.options.imageOptions.imageSize = this.imgSize / 10;
        }
        return this.options.imageOptions.imageSize * 10;
      },
      set(val) {
        this.imgSize = val;
        this.options.imageOptions.imageSize = val / 10;
        this.$emit("update", true);
      },
    },

    // NEW: Computed property to show a limited or full list of logos
    displayedLogos() {
      if (this.galleryExpanded) {
        return this.predefinedLogos;
      }
      // .slice(0, 15) will return the first 15 items.
      return this.predefinedLogos.slice(0, this.initialLogoLimit);
    },
  },

  methods: {
    getImg(file) {
      if (!!file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          this.options.image = reader.result;
          this.$emit("update", true);
        };
      } else {
        this.options.image = "";
        this.$emit("update", true);
      }
    },

    selectPredefinedLogo(logoUrl) {
      this.options.image = logoUrl;
      this.customLogoFile = null;
      this.$emit("update", true);
    },

    clearLogo() {
      this.options.image = "";
      this.customLogoFile = null;
      this.$emit("update", true);
    },

    // NEW: Method to toggle the gallery view
    toggleGallery() {
      this.galleryExpanded = !this.galleryExpanded;
    },
  },
};
</script>

<style scoped>
/* Styles for the predefined logos gallery are the same */
.predefined-logos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  /* NEW: Add transition for smoother expand/collapse */
  transition: max-height 0.5s ease-in-out;
}

.logo-item {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  background-color: #f5f5f5;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.logo-item:hover {
  transform: scale(1.05);
  border-color: #022494;
}

.logo-item.selected {
  border-color: #011554;
  box-shadow: 0 0 8px rgba(1, 41, 82, 0.5);
}

.logo-item img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  padding: 4px;
}
.btn-border{
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  border-bottom-color: #011554;
  border-left-color: #011554;
  border-right-color: #011554;
  border-right: 2px solid #011554;
  border-left: 2px solid #011554;
  border-bottom: 2px solid #011554;
  /* background-color: #011554; */
   color: #011554 !important; 
}
</style>
